import { createContext, useState } from "react";

const navbarContext = createContext({
  sidebarClose: true,
  setSidebarClose: () => {},
  loading: false,
  setLoading: () => {},
  errors: [],
  setErrors: () => {},
  sideDrawerIsOpen: false,
  setSideDrawerIsOpen: () => {},
});

export const NavbarProvider = ({ children }) => {
  const [count, setCount] = useState("50");
  const [pair, setPair] = useState("USDT");
  const [period, setPeriod] = useState("1h");
  const [signal, setSignal] = useState("signalall");
  const [exchanges, setExchanges] = useState("binance");
  const [search, setSearch] = useState("");
  // header state
  const [navbarData, setNavbarData] = useState([]);

  // navbar context value
  const navbarValue = {
    count,
    setCount,
    pair,
    setPair,
    period,
    setPeriod,
    signal,
    setSignal,
    exchanges,
    setExchanges,
    search,
    setSearch,
    navbarData,
    setNavbarData,
  };

  return (
    <navbarContext.Provider value={navbarValue}>
      {children}
    </navbarContext.Provider>
  );
};

export default navbarContext;
